export const isIncompleteUser = (user: any): boolean => {
  // SSO users excluded from phone number requirement
  const missingPhone = !user.identities && !user.phone_number;
  const missingName = !user.given_name || !user.family_name;
  return missingName || missingPhone;
};
